const data = [
  {
    header_1: "01",
    header_2: "Leverage",
    description: "We knit textiles embedded with sensors and actuators that you can integrate into your existing solutions, granting your product the transformative ability to sense and react to the human body."
  },
  {
    header_1: "02",
    header_2: "Integrate",
    description: "Building an innovative system that taps into the human body is easy if you harness the power of the SKIIN Textile Computing™ Platform. The platform consists of the textile-based hardware interface, the software backend that transmits and processes the data streams, and the API that allows developers to make sense of data for the end-user. Building upon the SKIIN platform provides enterprises a shortcut to developing more complex solutions and unlocking untapped potential."
  },
  {
    header_1: "03",
    header_2: "Co-design",
    description: "You bring the idea and Myant will bring the capability to design, engineer, prototype, and manufacture a Textile Computing™ solution.Let us work together to bring your innovation to the world."
  }
];

export default data;
